module.exports = __webpack_public_path__ + "img/btnStatus12.c67ab817.png";